export default [
  {
    header: 'navbars.sales',
    permission: [
      'sales_management',
      'finance_management',
      'supervisor',
      'manager',
      'super_manager',
    ],
    unique_name: 'clients-demo-page',
  },
  {
    title: 'navbars.presentation',
    route: 'clients-demo-page',
    icon: 'CodesandboxIcon',
    permission: ['sales_management', 'manager', 'super_manager'],
    unique_name: 'clients-demo-page',
  },
  {
    title: 'navbars.clients',
    route: 'clients',
    icon: 'UserIcon',
    permission: ['sales_management', 'supervisor', 'manager', 'super_manager'],
    unique_name: 'clients',
  },
  {
    title: 'navbars.kanban',
    icon: 'TrelloIcon',
    route: 'kanban',
    permission: [
      'sales_management',
      'finance_management',
      'supervisor',
      'manager',
      'super_manager',
    ],
    unique_name: 'kanban',
  },
]